__turbopack_context__.v({
  "button-intro": "secondary-navigation-module-scss-module__Nb0XEG__button-intro",
  "button-wrapper": "secondary-navigation-module-scss-module__Nb0XEG__button-wrapper",
  "icon": "secondary-navigation-module-scss-module__Nb0XEG__icon",
  "navigation": "secondary-navigation-module-scss-module__Nb0XEG__navigation",
  "navigation-toggle": "secondary-navigation-module-scss-module__Nb0XEG__navigation-toggle",
  "open": "secondary-navigation-module-scss-module__Nb0XEG__open",
  "overlay": "secondary-navigation-module-scss-module__Nb0XEG__overlay",
  "placeholder": "secondary-navigation-module-scss-module__Nb0XEG__placeholder",
  "root": "secondary-navigation-module-scss-module__Nb0XEG__root",
  "section": "secondary-navigation-module-scss-module__Nb0XEG__section",
  "title": "secondary-navigation-module-scss-module__Nb0XEG__title",
  "toggled": "secondary-navigation-module-scss-module__Nb0XEG__toggled",
  "visible": "secondary-navigation-module-scss-module__Nb0XEG__visible",
});
